import { InjectionToken } from '@angular/core';

import { ConfirmationModalData } from '../interfaces/confirmation-modal-data';

export const CONFIRMATION_MODAL_DATA = new InjectionToken<ConfirmationModalData>('CONFIRMATION_MODAL_DATA');
